import { render, staticRenderFns } from "./staffRepair.vue?vue&type=template&id=35dcdd32&scoped=true"
import script from "./staffRepair.vue?vue&type=script&lang=js"
export * from "./staffRepair.vue?vue&type=script&lang=js"
import style0 from "./staffRepair.vue?vue&type=style&index=0&id=35dcdd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dcdd32",
  null
  
)

export default component.exports